import React from 'react';
import RentReviewCalculator from '../../components/property-tools/RentReviewCalculator';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';

const RentReviewCalculatorPage: React.FC = () => {
  return (
    <LandlordToolkitLayout title="Rent Review Calculator">
      <RentReviewCalculator />
    </LandlordToolkitLayout>
  );
};

export default RentReviewCalculatorPage;
